<div class="create-order-container">
    <div class="widget-header">
        <span>{{ "landing.createorder" | cxTranslate }}</span>
    </div>
    <div class="widget-content">
        <vs-bulk-upload></vs-bulk-upload>
    </div>
</div>